// Photos from the night that can be folded away. Admin/band folds persist (onPersist); visitors fold just for themselves.
import { useEffect, useState } from "react";
import { ChevronDown, Images } from "lucide-react";
import { toast } from "sonner";
import { PhotoGrid, PhotoLightbox } from "./PhotoGrid";

export const FoldToggle = ({ open, onClick, count, dark = true, testid }) => (
  <button type="button" onClick={onClick} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${dark ? "bg-white/[0.07] text-white/80 hover:bg-white/[0.14]" : "bg-black/[0.06] text-[#1A1A1A] hover:bg-black/[0.12]"}`} aria-expanded={open} data-testid={testid}>
    <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />{open ? "Fold photos" : `Show photos${count ? ` · ${count}` : ""}`}
  </button>
);

export const useFold = (startFolded, onPersist) => {
  const [open, setOpen] = useState(!startFolded);
  useEffect(() => setOpen(!startFolded), [startFolded]);
  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (!onPersist) return;
    try { await onPersist(!next); toast.success(next ? "Photos open for everyone" : "Photos start folded for everyone"); } catch { setOpen(!next); toast.error("Couldn't save that"); }
  };
  return [open, toggle];
};

export const FoldablePhotos = ({ photos = [], columns = 3, startFolded = false, onPersist, label = "PHOTOS FROM THE NIGHT", dark = true, tileClass, testid = "fold-photos" }) => {
  const [open, toggle] = useFold(startFolded, onPersist);
  const [zoom, setZoom] = useState(null);
  if (!photos.length) return null;
  return (
    <div data-testid={testid} data-open={open ? "1" : "0"}>
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className={`m-0 inline-flex items-center gap-2 text-[11px] font-black tracking-[0.2em] ${dark ? "text-white/50" : "text-[#5C5C5C]"}`}><Images className="h-3.5 w-3.5" /> {label}</p>
        <FoldToggle open={open} onClick={toggle} count={photos.length} dark={dark} testid={`${testid}-toggle`} />
      </div>
      {open && <PhotoGrid photos={photos} columns={columns} onOpen={setZoom} tileClass={tileClass || (dark ? "bg-white/[0.04]" : "bg-black/5")} testid={`${testid}-grid`} />}
      {zoom != null && <PhotoLightbox photos={photos} index={zoom} onClose={() => setZoom(null)} />}
    </div>
  );
};
